

import React, { PureComponent } from 'react'
import { Button, Spinner } from 'react-bootstrap';
import { styleRules, __pick } from './utils';
import PropTypes from 'prop-types';
import * as _ from 'lodash'
import toast, { Toaster } from 'react-hot-toast';
import config from '../../constants/config'
declare const { defaultValue, value, ...inputAttributes }: React.InputHTMLAttributes<HTMLInputElement>;
type InputAttributes = typeof inputAttributes;
const DefaultButton = (props) => (<button {...props} />)

import { defaultOptionsToast, ToastMessage } from '../../constants/defaultOptionsToast';
const btnProps = [
    // HTML attributes
    "title",
    "style",
    "className",
    "disabled",
    "type",
    "id",
    // 'noShowResultMessageSuccess',
    // 'noShowResultMessageError',
    // Event listeners
    "onFocus",
    "onBlur",
    "onClick",
    "onKeyDown",

];
const colors = {
    red: "#cc0000",
    green: "#198c19",
}

export interface SpinnerProps {
    animation: 'border' | 'grow';
    role?: string;
    size?: 'sm';
    variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark';
    bsPrefix?: string;
}

// enum status {
//     loading = 'loading',
//     success = 'success',
//     error = 'error',
// }
export interface ButtonLoadingProps extends InputAttributes {
    bootstrap?: boolean
    block?: boolean
    onClickFetching?: (event?: React.MouseEvent<HTMLButtonElement>) => Promise<string>
    propsSpinner?: SpinnerProps
    timeShowMsg?: number
    clearResult?: boolean
    customResponseMessage?(msg: string, status: boolean): JSX.Element
    variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'dark'
    | 'light'
    | 'link'
    | 'outline-primary'
    | 'outline-secondary'
    | 'outline-success'
    | 'outline-danger'
    | 'outline-warning'
    | 'outline-info'
    | 'outline-dark'
    | 'outline-light';
    noShowResultMessageSuccess?: boolean
    noShowResultMessageError?: boolean
    showSpinner?: boolean
    customButton?: any,
    customButtonProps?: any
    processingComponent?: React.ReactNode
    // status?: status
}

const defaultProps = {
    disabled: false,
    bootstrap: true,
    clearResult: true,
    customResponseMessage: null,
    propsSpinner: null,
    type: "button",
    block: false,
    className: "",
    timeShowMsg: 2000,
    style: {
        backgroundColor: ''
    },
    noShowResultMessageSuccess: false,
    noShowResultMessageError: false,
    showSpinner: true,

    // variant: "primary"
}

const ButtonLoading: React.FunctionComponent<ButtonLoadingProps> = (props): JSX.Element => {

    const [loading, setLoading] = React.useState(false);
    const [show, setShow] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [isSuccessMsg, setIsSuccessMsg] = React.useState(false);
    // const [status, setStatus] = React.useState(null);


    const showMsg = (msg: string = "", success: boolean = false) => {
        setLoading(false)
        setIsSuccessMsg(success)
        setShow(true);
        setMsg(msg);

        if (props.clearResult && props.clearResult == true) {
            setTimeout(() => {
                clearResult()
            }, props.timeShowMsg);
        }

    }


    const clearResult = () => {
        setIsSuccessMsg(false)
        setShow(false);
        setMsg('');
    }



    /**
     *
     * @param e
     */
    const onClick = (e) => {
        if (props.onClick) {
            return props.onClick(e)
        }


        if (props.onClickFetching) {
            setLoading(true)
            props.onClickFetching(e).then((res) => {
                // showMsg(res, true)
                setLoading(false)
                if (!props.noShowResultMessageSuccess) {
                    toast.success((t) => (
                        <ToastMessage message={res} t={t} />
                    ), defaultOptionsToast);
                }




            }).catch((error) => {

                const msgError = _.has(error, "message") ? `${error.message}` : `${error}`
                if (!props.noShowResultMessageError) {
                    toast.error((t) => (
                        <ToastMessage message={msgError} t={t} />
                    ), defaultOptionsToast);
                }


                setLoading(false)
                // showMsg("" + error, false)
            })
        }
    }

    const renderProcessingComponent = () => {

        if (props.processingComponent) {
            return <>{props.processingComponent}</>
        }
        return <><Spinner animation="border" {...props.propsSpinner} /><span className='ml-1 mr-1'>Loading... </span></>
    }


    const renderMessage = (): JSX.Element => {
        if (props.customResponseMessage) {
            return props.customResponseMessage(msg, isSuccessMsg)
        }
        return (
            <span style={{ color: isSuccessMsg ? colors.green : colors.red }} >{msg}</span>
        )
    }

    const { block } = props
    let classBtn = props.bootstrap ? "btn" : ""
    let className = `${classBtn} ${props.variant ? `btn-${props.variant}` : ""} ${props.className} ${block ? "btn-block" : ""}`

    let Button = DefaultButton
    let customButtonProps = {}

    if (props.customButton) {
        Button = props.customButton
        customButtonProps = props.customButtonProps || {}
    }
    const renderButton = () => {
        return (
            <Button
                {...__pick(props, btnProps)}
                {...customButtonProps}
                disabled={(loading || show) ? true : props.disabled}
                className={className}
                onClick={(e) => onClick(e)}  >
                {(loading && props.showSpinner) ? <>   {renderProcessingComponent()} </>
                    : props.children}
            </Button>
        )
    }


    if (show) {
        return (
            <div className="d-flex flex-column">
                <div className="d-flex">
                    <span className="" style={{ flex: 1, padding: 5, alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}>
                        {renderMessage()}
                    </span></div>
                <div className="d-flex">
                    {renderButton()}
                </div>

            </div>
        )
    }

    return renderButton()
}

ButtonLoading.defaultProps = defaultProps;
export default ButtonLoading;
export { ButtonLoading };
